import { createContext, useContext } from 'react'

import type { RefObject } from 'react'

export const TooltipPortalContext = createContext<RefObject<HTMLDivElement | null> | null>(null)

/**
 * Hook to access the tooltip portal container ref.
 * Returns the ref to be used with UNSAFE_PortalProvider for React-Aria tooltips.
 */

export function useTooltipPortalContainer() {
  return useContext(TooltipPortalContext)
}
